module.exports = __webpack_public_path__ + "DINNextLTPro-LightCondensed.woff2?3d1045ed41ea99314ed4b3a955340aeb";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-LightCondensed.woff2
// module id = 1433
// module chunks = 0